import {Col as RBCol, Row as RBRow} from "react-bootstrap"
import styled from "styled-components"

import {SpacingProps, spacingCss} from "../global/css"

export const Col = styled(RBCol)<SpacingProps>`
  ${spacingCss}
`

export const Row = styled(RBRow)<SpacingProps>`
  ${spacingCss}
`
